module.exports = __webpack_public_path__ + "static/media/confirmMobileIcon.7226d3af.png";